/* 🤖 this file was generated by svg-to-ts*/
export const icoInformationSignDuo: {
  name: 'information-sign-duo';
  data: string;
} = {
  name: 'information-sign-duo',
  data: `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M32 52C43.0457 52 52 43.0457 52 32C52 20.9543 43.0457 12 32 12C20.9543 12 12 20.9543 12 32C12 43.0457 20.9543 52 32 52ZM32 54C44.1503 54 54 44.1503 54 32C54 19.8497 44.1503 10 32 10C19.8497 10 10 19.8497 10 32C10 44.1503 19.8497 54 32 54Z" fill="#858585"/>
<path d="M30 30C30 28.8954 30.8954 28 32 28C33.1046 28 34 28.8954 34 30V41C34 42.1046 33.1046 43 32 43C30.8954 43 30 42.1046 30 41V30Z" fill="#858585"/>
<path d="M30 23C30 21.8954 30.8954 21 32 21C33.1046 21 34 21.8954 34 23C34 24.1046 33.1046 25 32 25C30.8954 25 30 24.1046 30 23Z" fill="#858585"/>
<path opacity="0.12" d="M54 32C54 44.1503 44.1503 54 32 54C19.8497 54 10 44.1503 10 32C10 19.8497 19.8497 10 32 10C44.1503 10 54 19.8497 54 32Z" fill="#858585"/>
</svg>`
};
